import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { provide } from 'vue';
import { ModalDefinition } from '@/stores/modals';
import { MODAL_CONTROLS_KEY, MODAL_DEFINITION_KEY } from './provider-injection-keys';
import { useModalsStore } from '@/stores/modals';

interface Props {
  data: ModalDefinition;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalProvider',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ModalDefinition;
}

const modalsStore = useModalsStore();


provide(MODAL_DEFINITION_KEY, props.data);
provide(MODAL_CONTROLS_KEY, {
  close(immediate = false) {
    modalsStore.closeModal(props.data.id, immediate);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.data.component), _mergeProps({
    key: __props.data.id
  }, __props.data.props || {}, _toHandlers(__props.data.events || {})), null, 16))
}
}

})